import { Component, OnInit, Input, OnChanges, SimpleChanges,Output, EventEmitter, ViewChild} from '@angular/core';
import {FormGroup,FormBuilder,Validators,FormArray, AbstractControl} from '@angular/forms'
import{LoopBackAuth, listadosService, validacionService, parienteService,matriculaService} from '../../shared/services/api-rest.service';
import {ValidarIdentificacionDirective} from '../directive/validar-identificacion.directive'
import{MessageService} from '../../shared/services/message.service';
import{DatosEmergenciaComponent} from './datos-emergencia.component'
import { isNull } from 'util';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'datos-padres',
  template: `
  <form name="form-inscripciones" [formGroup]="padres" >
    <div class="row">
      <label class="col-sm-2 col-form-label text-right">
      Identificación:</label>
      <div class="col-sm-2 p-0">
          <div class="input-group input-group-sm mb-0">
              <select
              class="form-control"
              [style.border-radius]="'0px'"
              [style.height]="'28px'"
              formControlName="tipo"
              (change)="onChangeTipo($event.target.value); padres.get('identificacion').setValue('')"
              >
              <option *ngFor="let item of identificaciones" [value]="item.id">{{item.descripcion | uppercase}}</option>
              </select>
          </div>
      </div>
      <div class="col-sm-2 p-0">
        <div
            class="input-group input-group-sm mb-0"
            [ngClass]="{'showError': !padres.get('identificacion').valid && padres.get('identificacion').touched}">
            <input
                type="text"
                class="form-control"
                [style.border-radius]="'0px'"
                maxlength="{{maxLongitud}}"
                minlength="{{minLongitud}}"
                formControlName="identificacion"
                validarIdentificacion="{{padres.get('tipo').value}}"
                (blur)="verificarIdentificacion()"
            >
        </div>
      </div>
      <label class="col-sm-2 col-form-label text-right">
      Email: <span class="text-danger">*</span></label>
      <div class="col-sm-4 pl-0">
        <div
            [ngClass]="{'showError': !padres.get('email').valid && padres.get('email').touched}"
            class="input-group input-group-sm">
            <input
                type="text"
                [style.border-radius]="'0px'"
                class="form-control"
                formControlName="email"
            >
        </div>
      </div>
    </div>
    <div class="row">
        <label class="col-sm-2 col-form-label text-right">
        Apellidos: <span class="text-danger">*</span></label>
        <div class="col-sm-4 p-0">
            <div
                class="input-group input-group-sm"
                [ngClass]="{'showError': !padres.get('apellido').valid && padres.get('apellido').touched}">
                <input
                    type="text"
                    class="form-control"
                    [style.border-radius]="'0px'"
                    formControlName="apellido"
                    frmUppercase
                >
            </div>
        </div>
        <label class="col-sm-2 col-form-label text-right">
            Nombres: <span class="text-danger">*</span></label>
        <div class="col-sm-4 pl-0">
            <div
                class="input-group input-group-sm"
                [ngClass]="{'showError': !padres.get('nombre').valid && padres.get('nombre').touched}">
                <input
                    type="text"
                    class="form-control"
                    [style.border-radius]="'0px'"
                    formControlName="nombre"
                    frmUppercase
                >
            </div>
        </div>
    </div>
    <div class="row">
      <label class="col-sm-2 col-form-label text-right">
      Estado civil:	<span class="text-danger">*</span></label>
      <div class="col-sm-2 p-0">
          <div
              class="input-group input-group-sm"
              [ngClass]="{'showError': !padres.get('estadoCivil').valid && padres.get('estadoCivil').touched}">
              <select
              class="form-control"
              [style.border-radius]="'0px'"
              formControlName="estadoCivil"
              >
              <option *ngFor="let item of estadosCiviles" [value]="item.id">{{item.descripcion | uppercase}}</option>
            </select>
          </div>
      </div>
    </div>
    <div class="row">
      <label class="col-sm-2 col-form-label text-right">
              Instrucción: <span class="text-danger">*</span></label>
      <div class="col-sm-10">
          <div
              class="input-group input-group-sm"
              [ngClass]="{'showError': !padres.get('instruccion').valid && padres.get('instruccion').touched}">
              <select
              class="form-control"
              [style.border-radius]="'0px'"
              formControlName="instruccion"
              >
              <option [value]="null">SELECCIONE UNA OPCIÓN </option>
              <option *ngFor="let item of instrucciones" [value]="item.id">{{item.descripcion | uppercase}}</option>
              </select>
          </div>
        </div>
      <label class="col-sm-2 col-form-label text-right">
              Profesión: <span class="text-danger">*</span></label>
      <div class="col-sm-4">
          <div
          class="input-group input-group-sm"
          [ngClass]="{'showError': !padres.get('profesion').valid && padres.get('profesion').touched}">
          <input
              type="text"
              class="form-control"
              [style.border-radius]="'0px'"
              formControlName="profesion"
              frmUppercase
          >
          </div>
      </div>
      <!-- div class="col-sm-10">
          <div
              class="input-group input-group-sm"
              [ngClass]="{'showError': !padres.get('profesion').valid && padres.get('profesion').touched}">
              <select
              class="form-control"
              [style.border-radius]="'0px'"
              formControlName="profesion"
              >
              <option [value]="null">SELECCIONE UNA OPCIÓN </option>
              <option *ngFor="let item of profesiones" [value]="item.id">{{item.descripcion | uppercase}}</option>
              </select>
          </div>
      </div -->
      <label class="col-sm-2 col-form-label text-right">
              Ocupación: <span class="text-danger">*</span></label>
      <div class="col-sm-4">
          <div
          class="input-group input-group-sm"
          [ngClass]="{'showError': !padres.get('ocupacion').valid && padres.get('ocupacion').touched}">
          <input
              type="text"
              class="form-control"
              [style.border-radius]="'0px'"
              formControlName="ocupacion"
              frmUppercases
          >
          </div>
      </div>
      <!-- div class="col-sm-10">
          <div
              class="input-group input-group-sm"
              [ngClass]="{'showError': !padres.get('ocupacion').valid && padres.get('ocupacion').touched}">
              <select
              class="form-control"
              [style.border-radius]="'0px'"
              formControlName="ocupacion"
              >
              <option [value]="null">SELECCIONE UNA OPCIÓN </option>
              <option *ngFor="let item of ocupaciones" [value]="item.id">{{item.descripcion | uppercase}}</option>
              </select>
          </div>
      </div -->
    </div>
    <h3 class="f-12 text-primary">Domicilio</h3>
    <hr/>
    <div class="row">
        <label class="col-sm-2 col-form-label text-right">
        Dirección: <span class="text-danger">*</span></label>
        <div class="col-sm-6 pl-0">
          <div
              [ngClass]="{'showError': !padres.get('direccion').valid && padres.get('direccion').touched}"
                class="input-group input-group-sm">
              <input
                  type="text"
                  [style.border-radius]="'0px'"
                  class="form-control"
                  placeholder="Dirección de la vivienda, calle principal, calle secundaria y referencia"
                  formControlName="direccion"
                  frmUppercase
              >
          </div>
        </div>
        <label class="col-sm-2 col-form-label text-right">
        Sector/Barrio: <span class="text-danger">*</span></label>
        <div class="col-sm-2 pl-0">
          <div
              [ngClass]="{'showError': !padres.get('sector').valid && padres.get('sector').touched}"
                class="input-group input-group-sm">
              <input
                  type="text"
                  [style.border-radius]="'0px'"
                  class="form-control"
                  formControlName="sector"
                  frmUppercase
              >
          </div>
        </div>
    </div>
    <h3 class="f-12 text-primary">Trabajo</h3>
    <hr/>
    <div class="row">
      <label class="col-sm-2 col-form-label text-right">
      Institución: <span class="text-danger">*</span></label>
      <div class="col-sm-4 pl-0">
        <div
            [ngClass]="{'showError': !padres.get('trabajo').valid && padres.get('trabajo').touched}"
              class="input-group input-group-sm">
            <input
                type="text"
                [style.border-radius]="'0px'"
                class="form-control"
                placeholder="Lugar de trabajo"
                formControlName="trabajo"
                frmUppercase
            >
        </div>
      </div>
      <label class="col-sm-2 col-form-label text-right">
      Referencia: <span class="text-danger">*</span></label>
      <div class="col-sm-4 pl-0">
        <div
            [ngClass]="{'showError': !padres.get('referenciaTrabajo').valid && padres.get('referenciaTrabajo').touched}"
              class="input-group input-group-sm">
            <input
                type="text"
                [style.border-radius]="'0px'"
                class="form-control"
                placeholder="Referencia del lugar de trabajo"
                formControlName="referenciaTrabajo"
                frmUppercase
            >
        </div>
      </div>
      <label class="col-sm-2 col-form-label text-right">
        Dirección:</label>
        <div class="col-sm-6 pl-0">
          <div
              [ngClass]="{'showError': !padres.get('direccionTrabajo').valid && padres.get('direccionTrabajo').touched}"
                class="input-group input-group-sm">
              <input
                  type="text"
                  [style.border-radius]="'0px'"
                  class="form-control"
                  placeholder="Dirección del trabajo, calle principal, calle secundaria"
                  formControlName="direccionTrabajo"
                  frmUppercase
              >
          </div>
        </div>
        <label class="col-sm-2 col-form-label text-right">
        Sector/Barrio: <span class="text-danger">*</span></label>
        <div class="col-sm-2 pl-0">
          <div
              [ngClass]="{'showError': !padres.get('sectorTrabajo').valid && padres.get('sectorTrabajo').touched}"
                class="input-group input-group-sm">
              <input
                  type="text"
                  [style.border-radius]="'0px'"
                  class="form-control"
                  formControlName="sectorTrabajo"
                  frmUppercase
              >
          </div>
        </div>
    </div>
    <div class="row">
      <label class="col-sm-2 col-form-label text-right">
        Telefonos: <span class="text-danger">*</span></label>
      <div class="col-sm-12">
        <datos-emergencia [emergencias]="padres.get('telefonos')" [preview]="activarTelefonos"> </datos-emergencia>
      </div>
    
    </div>
    <div class="row mt-2">
      <div class="col-12 d-flex justify-content-center">
          <button 
            type="button" 
            class="btn btn-primary pb-1 pt-1" 
            (click)="guardar()"
            [hidden]="preview">
              <i class="fas fa-save"></i> Guardar
          </button>
      </div>
    </div>
  </form>
  `,
  providers:[LoopBackAuth, listadosService, validacionService, MessageService, parienteService,matriculaService]
})
export class DatosPadresComponent implements OnInit, OnChanges {
  @Input() padres : FormGroup
  @Input() idEstudiante: String
  @Input() idMatricula: String
  @Input() idEstado: String
  @Input() idTipoParentesco: string = null
  @Input() spinner: any
  @Input() preview: boolean = false
  @Input() escribir: string = "1"
  @Input() esAdmin: boolean = false  

   /** Salida */
   @Output() emitGuardarDatos  = new EventEmitter()
  
  public identificaciones: any[]
  public ocupaciones: any[]
  public profesiones:any[]
  public instrucciones:any[]
  public estadosCiviles:any[]
  public activarTelefonos: boolean = false
  public maxLongitud:number = 13
  public minLongitud:number = 3

  @ViewChild(ValidarIdentificacionDirective) validarIdentificacion: ValidarIdentificacionDirective

  constructor(
    private listadosService:listadosService,
    private fb: FormBuilder,
    private val: validacionService,
    private parienteService:parienteService,
    private toastr: ToastrService,
    private matriculaService:matriculaService
  ) { }

  ngOnInit() {
     /** Busco el listado de identificador por el tipo 3 */
    this.spinner.isSpinnerVisible = true
    this.activarTelefonos = this.preview
    this.listadosService.identificaciones(3).subscribe(
      result=>{
        this.identificaciones = result.sort((x,y)=> x.orden - y.orden)
        this.onPreview()
        if(isNull(this.padres.get('tipo').value)){
          this.padres.patchValue({ tipo : this.val.gruposDefecto(this.identificaciones,2)})
          this.onChangeTipo(this.val.gruposDefecto(this.identificaciones,2))
        }
          
      }
    )
    /** Lista de estado civil, ocupacion, profesiones */
    this.listadosService.grupos('G_ESTADO_CIVIL,G_OCUPACION,G_PROFESION,G_INSTRUCCION').subscribe(
      grupos =>{
        if(grupos != null){
          this.estadosCiviles = grupos['G_ESTADO_CIVIL'].orden
          this.ocupaciones = grupos['G_OCUPACION'].orden
          this.profesiones =  grupos['G_PROFESION'].orden
          this.instrucciones = grupos['G_INSTRUCCION'].orden
          this.porDefectoGrupos()
        }
        this.spinner.isSpinnerVisible = false

      }
    )
    //if(this.padres.get('identificacion').value =="5555555555555") this.escribir = "5555555555555"
    //if(this.padres.get('identificacion').value =="6666666666666") this.escribir = "6666666666666"
  }

  /** Inicializo los combos con campos por defecto */
  private porDefectoGrupos(){
    
    this.padres.patchValue({parentesco:this.idTipoParentesco})
     /** Inicializacon el valor por defecto si es null */
     if(isNull(this.padres.get('tipo').value))
     this.padres.patchValue({ tipo : this.val.gruposDefecto(this.identificaciones,2)})

    /** Inicializacon el valor por defecto si es null */
    if(isNull(this.padres.get('estadoCivil').value))
    this.padres.patchValue({ estadoCivil : this.val.gruposDefecto(this.estadosCiviles,2)})

    if(isNull(this.padres.get('instruccion').value))
    this.padres.patchValue({ instruccion : 136})
  
    /** Inicializacon el valor por defecto si es null */
    //if(isNull(this.padres.get('profesion').value))
      //this.padres.patchValue({ profesion : this.val.gruposDefecto(this.profesiones,1)})

    /** Inicializacon el valor por defecto si es null */
    //if(isNull(this.padres.get('ocupacion').value))
      //this.padres.patchValue({ ocupacion : this.val.gruposDefecto(this.ocupaciones,1)})
  }

  ngOnChanges(changes:SimpleChanges) {
    /** Verifico si el campo escritura cambia */
    if(changes.escribir!= undefined && changes.escribir.currentValue != undefined){
      console.log("Escritura -->", changes.escribir)
      if(changes.escribir.currentValue == "1" && (this.padres.get('identificacion').value == "5555555555555" || this.padres.get('identificacion').value == "6666666666666" )){
        let telefonos = this.padres.get('telefonos') as FormArray
        telefonos.removeAt(0)
        this.padres.reset()
        this.porDefectoGrupos()
        this.activarTelefonos = false
      }
      
      if(changes.escribir.currentValue == "5555555555555" || changes.escribir.currentValue == "6666666666666"){
        this.padres.get('identificacion').setValue(changes.escribir.currentValue)
        this.verificarIdentificacion()
        this.activarTelefonos = true
      }
      this.onPreview()
      this.porDefectoGrupos()
    }
      
  }

  public verificarIdentificacion(){
    if(this.padres.get('identificacion').value.length > 9){
      this.parienteService.findIdentificacion(this.padres.get('identificacion').value,this.idEstudiante).subscribe(
        datos =>{
          if(!isNull(datos)){
           console.log("Datos buscados parentesco -->", datos)
            this.padres.patchValue(
              {
                id: datos.aca_parentesco_codigo,
                parentesco: datos.aca_parentesco_tipo_id,
                tipo: datos.tipo_identificacion_glb_identificacion_id,
                identificacion: datos.identificacion,
                email: datos.correo_electronico,
                apellido:datos.apellido,
                nombre:datos.nombre,
                direccion:datos.direccion,
                sector: datos.sector,
                estadoCivil: datos.estado_civil_glb_global_listado_id,
                instruccion: datos.instruccion_glb_global_listado_id,
                //profesion:datos.profesion_glb_global_listado_id,
                //ocupacion:datos.ocupacion_glb_global_listado_id,
                profesion:datos.profesion,
                ocupacion:datos.ocupacion,
                trabajo: datos.lugar_trabajo,
                direccionTrabajo:datos.direccion_trabajo,
                referenciaTrabajo:datos.referencia_trabajo,
                sectorTrabajo: datos.sector_trabajo
              }
            )
            this.onChangeTipo(datos.tipo_identificacion_glb_identificacion_id)
            this.porDefectoGrupos()
            let telefonos = this.padres.get('telefonos') as FormArray
            telefonos.removeAt(0)
            this.asignarTelefonos(this.padres.get('telefonos'), datos.telefonos)
           
          }
        }
      )
    }
      
  }

  public onChangeTipo(event: any){
    let tipo = this.identificaciones.filter((x:any)=> x.id == event)[0]
    this.maxLongitud = tipo.maximo
    this.minLongitud = tipo.minimo
  }

  /** Asigna los telefonos de emergencia y de padres */
  private asignarTelefonos(control: AbstractControl , datos:any){
    /** Telefonos de emergencia */
    var telefonos = control as FormArray
    for(let i=0 ; i < datos.length; i++){
      let item = datos[i]
      telefonos.push(
        this.fb.group({
          id:[item.id],
          etiqueta: [item.etiqueta_glb_global_listado_id],
          operadora:[item.operadora_glb_global_listado_id],
          tipo:[item.tipo_glb_global_listado_id],
          numero:[item.telefono],
          extencion:[item.extension],
          contacto:[item.contacto],
          predeterminado:[item.predeterminado],
          estado:[1],
          existe:[1]
        })
      )
    }
  }

  /** Prender o apagar los campos */
  private onPreview(){
    if(this.preview || !(this.escribir == "1")){
      this.padres.disable()
    }else{
      this.padres.enable()
    }
  }

  /** Validar formulario */
  private validaFormParentesco(){
    //if(this.esAdmin) return true
    //if(this.escribir != "1") return true
    let contador = 0
    let padre = this.padres as FormGroup
    Object.keys(padre.controls).forEach(field => {
      const control = this.padres.get(field)
      if(field == 'identificacion' && !isNull(this.validarIdentificacion.validate(control))){
        if(!(padre.get('identificacion').value == '6666666666666' || padre.get('identificacion').value == '5555555555555')){
          control.markAsTouched({ onlySelf: true })
          contador ++
        }
      }
      if(!isNull(control.errors)){
        console.log("Campo Validar "+field,control.errors, control.value)
        control.markAsTouched({ onlySelf: true })
        contador ++
      }
    })

    let telefonos  = this.padres.get('telefonos') as FormArray
    if(telefonos.controls.length == 0) return false
  
    for(let i=0; i < telefonos.controls.length ; i++){
      let telefono = telefonos.controls[i] as FormGroup
      Object.keys(telefono.controls).forEach(field => {
        const control = telefono.get(field)
        if(!isNull(control.errors)){
          console.log("Campo Validar "+field,control.errors, control.value)
          control.markAsTouched({ onlySelf: true })
          contador ++
        }
      })
    }
    return (contador > 0) ? false :true
  }

  /** Guardar formulario */
  public guardar(){
    if(!this.validaFormParentesco()){
      this.toastr.error("Falta campos de ingresar, deben estar pintados de color rojo","Pestaña Representante")
      return null
    } 
    this.matriculaService.statusChange(this.idMatricula,this.idEstado).subscribe()
    this.spinner.isSpinnerVisible = true
    this.parienteService.create(this.idEstudiante,this.padres.getRawValue()).subscribe(
      pariente =>{
        if(pariente != null){
          this.toastr.success("Datos del pariete guardados","Éxito")
          this.padres.patchValue({
            id: pariente.aca_parentesco_id,
          })
        
          this.spinner.isSpinnerVisible = false
          this.emitGuardarDatos.emit(pariente.aca_parentesco_id)
        }
        this.spinner.isSpinnerVisible = false
      }
    )

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/fichaEstudiante/datos-padres.component.ts